<nav class="navbar fixed-top navbar-expand-md navbar-dark navbar-main navbar-fade">
  <div class="container">
    <div class="float-left">
      <a [routerLink]="['/']">
        <span class="navbar-brand navbar-heading pl-1">zeszyt.online</span>
      </a>
    </div>
  </div>
</nav>
